<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Ajout formation">
        <v-form v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formation.libelle"
                label="Libellé REO"
                @input="resetApiErrors('libelle')"
                :error-messages="checkApiErrors('libelle')"
                :rules="libelleRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="formation.eligible"
                label="Eligible"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="formation.diplome"
                :items="itemsDiplome"
                hint="Type du diplôme"
                item-text="libelle"
                item-value="id"
                label="Choix du type de diplôme"
                persistent-hint
                return-object
                single-line
                :rules="selectRules"
                @input="resetApiErrors('diplome')"
                :error-messages="checkApiErrors('diplome')"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" offset-md="2">
              <v-select
                v-model="formation.niveau"
                :items="itemsNiveau"
                hint="Niveau de la formation"
                item-text="libelle"
                item-value="id"
                label="Choix du niveau de la formation"
                persistent-hint
                return-object
                single-line
                :rules="selectRules"
                @input="resetApiErrors('niveau')"
                :error-messages="checkApiErrors('niveau')"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="formation.structure"
                :items="itemsStructure"
                hint="Structure"
                item-text="libelle"
                item-value="id"
                label="Choix de la structure"
                persistent-hint
                return-object
                single-line
                :rules="selectRules"
                @input="resetApiErrors('structure')"
                :error-messages="checkApiErrors('structure')"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="formation.campus"
                :items="itemsCampus"
                hint="Campus"
                item-text="libelle"
                item-value="id"
                label="Choix du campus"
                persistent-hint
                return-object
                single-line
                :rules="selectRules"
                @input="resetApiErrors('campus')"
                :error-messages="checkApiErrors('campus')"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="valider"
                  :loading="loading"
                >
                  <v-icon left>save</v-icon>Valider
                </v-btn>
                <router-link
                  :to="{
                    name: 'boListFormations',
                  }"
                >
                  <v-btn class="ma-2" color="primary">Annuler</v-btn>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import ApiStructureRepository from "@/repositories/ApiStructureRepository";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "FormAjoutFormation",
  components: { BaseBlock, BaseAlert },
  extends: BaseForm,
  data() {
    return {
      valid: false,
      loading: false,
      itemsStructure: [],
      itemsCampus: [],
      itemsDiplome: [],
      itemsNiveau: [],
      formation: {
        libelle: "",
        eligible: true,
        structure: {},
        campus: {},
        diplome: {},
        niveau: {},
      },
      libelleRules: [(v) => !!v || "Le libelle est requis"],
      dateRules: [(v) => !!v || "La date est requise"],
      selectRules: [(v) => !(v.id == undefined) || "Un choix est requis"],
    };
  },
  computed: {},
  methods: {
    async valider() {
      try {
        this.loading = true;
        const boFormation = await ApiFormationRepository.ajoutFormation(
          this.formation
        );
        this.formation = boFormation;
        this.$toast.success("La formation a été ajoutée");
        this.$router.push("boListFormations");
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loading = false;
      }
    },

    async getTypeDiplomes() {
      try {
        const typesDiplome = await ApiFormationRepository.getTypesDiplomes();
        this.itemsDiplome = typesDiplome;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getCampusLst() {
      try {
        const campusLst = await ApiCampusRepository.getCampusLst();
        this.itemsCampus = campusLst;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getStructuresLst() {
      try {
        const structuresLst = await ApiStructureRepository.getListeStructures();
        this.itemsStructure = structuresLst;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getNiveauxFormations() {
      try {
        const niveaux = await ApiFormationRepository.getNiveauxFormations();
        this.itemsNiveau = niveaux;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
  created() {
    this.getTypeDiplomes();
    this.getCampusLst();
    this.getStructuresLst();
    this.getNiveauxFormations();
  },
};
</script>
